import { Component, NgZone, OnInit } from '@angular/core';

import { ErrorTracking } from './error-tracking.service';

@Component({
  selector: 'fl-memory-leak-tracking',
  template: `<ng-container></ng-container>`,
})
export class MemoryLeakTrackingComponent implements OnInit {
  readonly CHECK_INTERVAL = 10000; // 10 seconds
  readonly MAX_MEMORY_LIMIT = 1000 * 1048576; // 1000MB
  readonly MAX_PERCENT_THRESHOLD = 90;

  hadAlarmed = false;

  constructor(private errorTracking: ErrorTracking, private ngZone: NgZone) {}

  ngOnInit() {
    if (!(window.performance && (<any>window.performance).memory)) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.checkMemoryUsage();
        });
      }, this.CHECK_INTERVAL);
    });
  }

  checkMemoryUsage() {
    requestAnimationFrame(() => {
      let hasAlarmed = false;
      const {
        jsHeapSizeLimit,
        totalJSHeapSize,
        usedJSHeapSize,
      } = (<any>window.performance).memory;

      // Check if we've exceeded absolute memory limit
      if (usedJSHeapSize > this.MAX_MEMORY_LIMIT) {
        hasAlarmed = true;
        const overage = usedJSHeapSize - this.MAX_MEMORY_LIMIT;
        this.errorTracking.captureMessage('Exceeded memory maximum limit', {
          extra: { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize, overage },
        });
      }

      // Check if we've exceeded relative memory limit for client
      if (usedJSHeapSize > this.MAX_PERCENT_THRESHOLD / 100 * jsHeapSizeLimit) {
        hasAlarmed = true;
        this.errorTracking.captureMessage('Memory usage exceeded', {
          extra: {
            jsHeapSizeLimit,
            totalJSHeapSize,
            usedJSHeapSize,
            MAX_PERCENT_THRESHOLD: this.MAX_PERCENT_THRESHOLD,
          },
        });
      }

      // Only alert once
      if (!hasAlarmed) {
        setTimeout(() => this.checkMemoryUsage(), this.CHECK_INTERVAL);
      }
    });
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/app/@shared/tracking/memory-leak-tracking.component.ts